import EyeDrawSection from '../EyeDrawSection';
import thumb26 from '../images/thumb_26.jpg';
import thumb27 from '../images/thumb_27.jpg';
import thumb28 from '../images/thumb_28.jpg';
import thumb29 from '../images/thumb_29.jpg';
import img26 from '../images/26.png';
import img27 from '../images/27.png';
import img28 from '../images/28.png';
import img29 from '../images/29.png';

const cards = [
    { title: 'Retina - AMD Dry', thumb: thumb26, image: img26 },
    { title: 'Retina - AMD Wet', thumb: thumb27, image: img27 },
    { title: 'Retina - Diabetic Retinopathy', thumb: thumb28, image: img28 },
    { title: 'Retina Detachment', thumb: thumb29, image: img29 },
];

export default function Retina() {
    return <EyeDrawSection id="retina" title="Retina" icon="bi-bullseye" cards={cards} />;
}
